import React, {useContext} from 'react';
import PayPalBtn2 from './PayPalBtn2'
import moment from 'moment'
import {db} from '../../../services/firebase'
import firebase from 'firebase'
import { connect } from 'react-redux';
import ReactPixel from 'react-facebook-pixel'

let user = ''

const paypalSubscribe = (data, actions) => {
  return actions.subscription.create({
    'plan_id': "P-4N172726DT148104AL6NM56Y",
  });
};

const paypalOnError = (err) => {
  alert('Error! Please try again.')
}

const paypalOnApprove = (data, detail) => {
  ReactPixel.track('Purchase', {
          value: 25,
          email: user.email,
          type: 'reocurring',
          frequency: 'monthly'
  })
  let date = moment().format('MMMM Do YYYY, h:mm:ss a')
  db.collection('Deposits').doc(`${date}-${user.email}`).set({
    user: user.email,
    amount: 250,
    date: date,
    type: 'reocurring'
  })
  db.collection('Users').doc(user.email).update({
    cash: firebase.firestore.FieldValue.increment(250),
    currentMoneyDeposited: firebase.firestore.FieldValue.increment(250),
    totalValue: firebase.firestore.FieldValue.increment(250)
  }).then((result) => {
    alert('Deposit Successful! The funds will appear in the portfolio after the page is refreshed.')
    return window.location.href = "https://simbull.app";
  }).catch(err => console.log(err))
};


function PsMonthly250(props) {
  user = props.user
  return (
    <div className="App">
      <span className="paypal-subscription-amount">Monthly $250</span>
              <PayPalBtn2
                amount = "250"
                currency = "USD"
                createSubscription={paypalSubscribe}
                onApprove={paypalOnApprove}
                catchError={paypalOnError}
                onError={paypalOnError}
                onCancel={paypalOnError}
            />
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user.user,
});

export default connect(mapStateToProps)(PsMonthly250);